// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"25cbd9cb","453":"a30b4cbd","455":"86a87c55","977":"b118ffd6"}[chunkId] + ".chunk.js";
};